<template>
    <div id="app">
        <Nav class="limit-width" />
        <router-view class="limit-width"></router-view>
        <Footer class="limit-width" v-if="$router.currentRoute.name !== 'Blog'" />
    </div>
</template>

<script>
import Nav from './components/Nav'
import Footer from './components/Footer.vue';

export default {
    name: 'App',
    components:{ Nav, Footer },
}
</script>

<style>
#app{
    font-family: 'Times New Roman', Times, serif;
    width: 100%;
    min-width: 1000px;
    margin: 0 auto;
}
.limit-width{
    width: 100%;
    min-width: 1000px;
    margin: 0 auto;
}
strong {
    font-weight: bold;
}
</style>
